$('.happy-client-slide').owlCarousel({
    loop:true,
    nav:true,
    dots:false,
    autoHeight: true,
    navText: ["<i class='fa-solid fa-chevron-left'></i>","<i class='fa-solid fa-chevron-right'></i>"],
    margin:25,
   
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:2
        },
        1300:{
            items:2
        }
    }
})